<template>
	<button class="btn btn-orange" :class="[{'w-100' : fullWidth }, variant]"
			@click.prevent="$emit('onClick', 'event')">
		{{text}}
		<slot/>
	</button>
</template>

<script>
	export default {
		name: 'Button',
		data() {
			return {}
		},
		props: {
			text: "",
			variant: "",
			fullWidth: false,
		},
		emits: ["onClick"],
		methods: {},
	}
</script>
<style scoped lang="scss">
	.btn-orange {
		@include btn-orange;
		padding: 10px 25px;

		&.sm {
			padding: 12px 25px;
		}
		&.lg {
			padding: 17px 34px;
		}
		&.xl {
			padding: 20px 15px;
		}
	}
	
</style>
